module.exports = __webpack_public_path__ + "static/puck-main-z29-tablet-ac5847536b0b2e0bc5847216db347512.jpg";